import React, { useEffect, useState } from 'react';
import { Language, translations } from './i18n/translations';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Product } from './pages/Product';
import { StickyMobileBar } from './components/StickyMobileBar';
export function App() {
  const [lang, setLang] = useState<Language>('es');
  const [page, setPage] = useState<'home' | 'product'>('home');
  const [selectedProductSlug, setSelectedProductSlug] = useState<string | null>(null);
  const t = translations[lang];
  // Scroll to top on page change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page, selectedProductSlug]);
  const handleSetPage = (newPage: 'home' | 'product', slug?: string) => {
    if (slug) {
      setSelectedProductSlug(slug);
    }
    setPage(newPage);
  };
  return <div className="min-h-screen flex flex-col bg-cream font-sans text-ink selection:bg-gold/30 selection:text-ink" data-id="element-0">
      <Header lang={lang} setLang={setLang} t={t} setPage={handleSetPage} data-id="element-1" />

      <div className="flex-1" data-id="element-2">
        {page === 'home' ? <Home t={t} setPage={handleSetPage} data-id="element-3" /> : <Product t={t} setPage={handleSetPage} slug={selectedProductSlug} lang={lang} data-id="element-4" />}
      </div>

      <Footer t={t} setPage={handleSetPage} data-id="element-5" />

      <StickyMobileBar t={t} isVisible={page === 'product'} data-id="element-6" />
    </div>;
}